import { render, staticRenderFns } from "./reduceRank.vue?vue&type=template&id=7d1e4f1e"
import script from "./reduceRank.vue?vue&type=script&lang=js"
export * from "./reduceRank.vue?vue&type=script&lang=js"
import style0 from "./reduceRank.vue?vue&type=style&index=0&id=7d1e4f1e&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports